<template>
  <div>
    <div class="real-content">
      <div class="realContent-minute1">
        <div class="minute1-now">
          <div class="minute1Now-name">{{$t("mobileInstantRainfall")}}</div>
          <div class="minute1Now-value">{{oneRainfall}}mm</div>
        </div>
        <div class="minute1-one">
          <div class="minute1One-name">{{$t("mobileOneMinute")}}</div>
          <div class="minute1One-value">{{oneRainfall}}mm</div>
        </div>
      </div>
      <div class="realContent-minute2">
        <div class="minute2-five">
          <div class="minute2Five-name">{{$t("mobileFiveMinute")}}</div>
          <div class="minute2Five-value">{{fiveRainfall}}mm</div>
        </div>
        <div class="minute2-ten">
          <div class="minute2Ten-name">{{$t("mobileFenMinute")}}</div>
          <div class="minute2Ten-value">{{tenRainfall}}mm</div>
        </div>
      </div>
      <div class="realContent-hour">
        <div class="hour-now">
          <div class="hourNow-name">{{$t("mobileCurrentPeriod")}}</div>
          <div class="hourNow-value">{{hourRainfall}}mm</div>
        </div>
        <div class="hour-last">
          <div class="hourLast-name">{{$t("mobilePreviousPeriod")}}</div>
          <div class="hourLast-value">{{lastHourRainfall}}mm</div>
        </div>
      </div>

      <div class="realContent-day">
        <div class="day-now">
          <div class="dayNow-name">{{$t("mobileDailyRainfall")}} {{dayRainState}}</div>
          <div :class="dayRainFlg == false ? 'dayNow-value' : 'dayNow-value1'">{{dayRainfall}}mm</div>
        </div>
      </div>

      <div class="realContent-input">
        <div class="input-boundary">
          <div class="inputBoundary-name">{{$t("mobileDaily")}}(0-23)</div>
          <div class="inputBoundary-value">
            <el-input  type='number' placeholder=0 v-model="input"></el-input>
          </div>
          <div class="inputBoundary-btn">
            <el-button round @click="setHourRain">{{$t("mobileSubmit")}}</el-button>
          </div>
        </div>
        <div class="input-warn">
          <div class="inputWarn-name">{{$t("mobileLine")}}</div>
          <div class="inputWarn-value">
            <el-input  type='number' placeholder=0 v-model="warnInput"></el-input>
          </div>
          <div class="inputWarn-btn">
            <el-button round @click="setMobileRainWarn">{{$t("mobileSubmit")}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {
    getTimeDeviceHistory,
    getAttributesClient,
    postClientInfo,
    getConnectTime
  } from "../untils/api/home"
  export default {
    name: 'mobileReal',
    data() {
      return {
        oneRainfall: '-',
        fiveRainfall: '-',
        tenRainfall: '-',
        hourRainfall: '-',
        lastHourRainfall: '-',
        dayRainfall: '-',
        dayRainState: '',
        deviceInfo: {},
        key: '',
        credentialsId: '',
        input:'',
        realInput: '',
        warnInput: '',
        realWarnInput: '',
        dayRainFlg: false,
        mobileRainFlg: false,
        hourTime: null,
        lastHourTime: null,
        dayTime: null,
      }
    },

    beforeDestroy() {
      let local = localStorage.getItem('locale');
      localStorage.clear();
      localStorage.setItem('locale',local)
      clearInterval(this.hourTime);
      this.hourTime = null;
      clearInterval(this.lastHourTime);
      this.lastHourTime = null;
      clearInterval(this.dayTime);
      this.dayTime = null;
    },

    methods: {
      /**
       * 初期化变量
       */
      initMobileReal(deviceInfo, credentialsId, key) {
        this.deviceInfo = deviceInfo;
        this.credentialsId = credentialsId;
        this.key = key;
        this.oneRainfall = '-';
        this.fiveRainfall = '-';
        this.tenRainfall = '-';
        this.hourRainfall = '-';
        this.lastHourRainfall = '-';
        this.dayRainfall = '-';
        this.dayRainState = '';
        this.input = '';
        this.realInput = '';
        this.warnInput = '';
        this.realWarnInput = '';
        this.dayRainFlg = false;
        this.mobileRainFlg = false;
        if(this.hourTime !== null){
          clearInterval(this.hourTime);
          this.hourTime = null;
        }
        if(this.lastHourTime !== null) {
          clearInterval(this.lastHourTime);
          this.lastHourTime = null;
        }
        if(this.dayTime != null){
          clearInterval(this.dayTime);
          this.dayTime = null;
        }
      },

      /**
       * 每隔一分钟获取一次一小时内雨量
       */
      minuteInfo() {
        this.mobileConnectTime();
        this.hourTime = window.setInterval(() => {
          setTimeout(() => {
            this.mobileConnectTime();
          }, 0)
        }, 1000 * 60);
      },

      /**
       * 获取最后一次更新时间，判断是否掉线
       */
      mobileConnectTime() {
        getConnectTime(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
          if(response[0].value > beforeTime){//在线
            this.mobileRainFlg = false;
            this.getHourHistory();
          } else if(!this.mobileRainFlg) {//离线
            this.oneRainfall = "-";
            this.fiveRainfall = "-";
            this.tenRainfall = "-";
            this.hourRainfall = "-";
            this.mobileRainFlg = true;
            this.$message({
              showClose: true,
              type:"warning",
              message: this.$t("mobileDeviceDisconnect")
            });
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 获取一小时内雨量
       */
      getHourHistory() {
        let startTime = new Date(moment().subtract(1,"hours")).getTime();
        let endTime = new Date(moment()).getTime();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          let zeroIndex = '';
          for(let obj in response){
            for(let i = 0; i < response[obj].length - 1; i++) {
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                zeroIndex = i;
                break;
              }
            }
          }
          if(JSON.stringify(response) === "{}") {
            this.oneRainfall = "-";
            this.fiveRainfall = "-";
            this.tenRainfall = "-";
            this.hourRainfall = "-";
            return;
          } else {
            this.setRealData(response, zeroIndex);//获取当前雨量
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取1，5，10分钟雨量以及当前时段雨量
       * @param response
       * @param zeroIndex
       */
      setRealData(response, zeroIndex) {
        let currentHour = new Date(moment().format('YYYY-MM-DD HH:00:00')).getTime();//整点时间
        for(let obj in response) {
          //一分钟雨量
          if(response[obj].length >= 2){//数据量大于两条
            this.oneRainfall = parseFloat(response[obj][0].value) - parseFloat(response[obj][1].value) < 0
              ? parseFloat(response[obj][0].value).toFixed(2)
              : (parseFloat(response[obj][0].value) - parseFloat(response[obj][1].value)).toFixed(2);
          } else {
            this.oneRainfall = parseFloat(response[obj][0].value).toFixed(2);//少于两条赋值为0
          }
          //五分钟雨量
          if(response[obj].length >= 6) {//数据量大于6条
            if(zeroIndex >= 5|| zeroIndex === ''){//判断0位置在前6条之后
              this.fiveRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][5].value)).toFixed(2);
            } else {//判断0位置在前6条之间
              this.fiveRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][5].value))).toFixed(2);
            }
          } else {//数据量小于6条
            if(response[obj].length === 1){//数据量为1
              this.fiveRainfall = parseFloat(response[obj][0].value).toFixed(2);
            } else {//数据量大于1
              if(zeroIndex >= response[obj].length - 1 || zeroIndex === ''){//判断0位置在最后一条及以后
                this.fiveRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
              } else {//判断0位置在最后一条之前
                this.fiveRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
              }
            }
          }

          //十分钟雨量
          if(response[obj].length >= 11) {//数据量大于11条
            if(zeroIndex >= 10|| zeroIndex === ''){//判断0位置在前11条之后
              this.tenRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][10].value)).toFixed(2);
            } else {//判断0位置在前11条之间
              this.tenRainfall =(parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][10].value))).toFixed(2);
            }
          } else {//数据量小于11条
            if(response[obj].length === 1){//数据量为1
              this.tenRainfall = parseFloat(response[obj][0].value).toFixed(2);
            } else {//数据量大于1
              if(zeroIndex >= response[obj].length - 1 || zeroIndex === ''){//判断0位置在最后一条及以后
                this.tenRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
              } else {//判断0位置在最后一条之前
                this.tenRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
              }
            }
          }

          //当前时段雨量
          let flg = false;
          for(let i = 0; i < response[obj].length; i++) {
            if(response[obj][i].ts === currentHour) {//获取最后一条位置
              if(i <= zeroIndex || zeroIndex === ''){//判断0位置在最后一条及以后
                this.hourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][i].value)).toFixed(2);
              } else {//判断0位置在最后一条之前
                this.hourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][i].value))).toFixed(2);
              }
              flg = true;
              break;
            } else if(response[obj][i].ts < currentHour){//获取最后一条位置
              if(i !== 0){//最后一条位置不为0
                if(i <= zeroIndex || zeroIndex === ''){//判断0位置在最后一条及以后
                  this.hourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][i - 1].value)).toFixed(2);
                } else {//判断0位置在最后一条之前
                  this.hourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][i - 1].value))).toFixed(2);
                }
              } else {//最后一条位置为0
                this.hourRainfall = parseFloat(response[obj][0].value).toFixed(2);
              }
              flg = true;
              break;
            }
          }
          //最后一条数据为当前时段内
          if(!flg){
            if(response[obj].length - 1 <= zeroIndex || zeroIndex === '') {//判断0位置在最后一条及以后
              this.hourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            } else {//判断0位置在最后一条之前
              this.hourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
            }
          }
        }
      },

      /**
       * 每隔一小时获取一次前一小时雨量
       */
      hourInfo() {
        this.getLastHistory();//获取一小时雨量
        this.lastHourTime = window.setInterval(() => {
          setTimeout(() => {
            this.getLastHistory();//获取一小时雨量
          }, 0)
        }, 1000 * 60 * 60);
      },

      /**
       * 获取前一小时雨量
       */
      getLastHistory() {
        let startTime = new Date(moment().startOf('hour').subtract(1,'hours')).getTime();
        let endTime = new Date(moment().startOf('hour')).getTime();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          if(JSON.stringify(response) === "{}") {
            this.lastHourRainfall = "-";
            return;
          }
          let zeroIndex = '';
          //获取0位置
          for(let obj in response) {
            for(let i = 0; i <response[obj].length - 1; i++) {
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                zeroIndex = i;
                break;
              }
            }
            //获取前一时段雨量
            if(zeroIndex === ''){
              this.lastHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            } else {
              this.lastHourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2)
            }
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 获取日分界时
       */
      getRainHour() {
        let boundaryNum = 0;
        let warnNum = 0;
        getAttributesClient(this.credentialsId).then(response => {
          for(let obj in response.client) {
            if(obj === 'rainHour'){
              boundaryNum = response.client[obj];
            }else if(obj === 'rainWarn'){
              warnNum = response.client[obj];
            }
          }
          this.input = boundaryNum;
          this.realInput = boundaryNum;
          this.warnInput = warnNum;
          this.realWarnInput = warnNum;
          this.dayInfo();//每隔24小时获取一次日雨量
        }).catch(error => {
          console.log("error",error);
        })
      },

      /**
       * 每隔24小时获取一次日雨量
       */
      dayInfo() {
        if(this.dayTime != null){
          clearInterval(this.dayTime);
          this.dayTime = null;
        }
        this.getDayHistory();
        this.dayTime = window.setInterval(() => {
          setTimeout(() => {
            this.getDayHistory();
          }, 0)
        }, 1000 * 60 * 60 * 12);
      },

      /**
       * 访问api获取日雨量
       */
      getDayHistory() {
       let format = 'YYYY-MM-DD ' + this.input + ':00:00';
        let startTime = new Date(moment().startOf('day').subtract(1,"days").format(format)).getTime();
        let endTime =  new Date(moment().startOf('day').format(format)).getTime();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          if(JSON.stringify(response) === "{}") {
            this.dayRainfall = "-";
            return;
          }
          let zeroIndex = '';
          //获取0位置
          for(let obj in response){
            for(let i = 0; i < response[obj].length - 1; i++) {
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                zeroIndex = i;
                break;
              }
            }
            //获取当天雨量
            if(zeroIndex === ''){
              this.dayRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            } else {
              this.dayRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][zeroIndex + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
            }
            if(parseFloat(this.dayRainfall) >= 50) {
              this.dayRainState = this.$t("mobileRainstorm");
            } else if(parseFloat(this.dayRainfall) >= 25) {
              this.dayRainState = this.$t("mobileHeavyRain");
            } else if(parseFloat(this.dayRainfall) >= 10) {
              this.dayRainState = this.$t("mobileModerateRain")
            } else if(parseFloat(this.dayRainfall) > 0) {
              this.dayRainState = this.$("mobileLightRain");
            } else {
              this.dayRainState = '';
            }
            this.mobileWarnDisplay();
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 设置警戒状态
       */
      mobileWarnDisplay() {
        if((parseFloat(this.dayRainfall) > parseFloat(this.warnInput)) && (parseFloat(this.warnInput) > 0)) {
          this.dayRainFlg = true;
        } else {
          this.dayRainFlg = false;
        }
      },

      /**
       * 设置日雨量分界时
       */
      setHourRain(){
        let hour = this.input === '' ? 0 : parseFloat(this.input);
        if(hour > 23 || hour < 0){
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t("mobileBoundaryWarn")
          });
          this.input = this.realInput;
        } else {
          let param = {rainHour: hour};
          postClientInfo(this.credentialsId, param).then(response => {
            this.realInput = this.input;
            this.$message({
              showClose: true,
              type: "info",
              message: this.$t("mobileBoundarySuccess")
            });
          }).catch(error => {
            this.input = this.realInput;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t("mobileBoundaryError")
            });
          })
          this.dayInfo();//每隔24小时获取一次日雨量
        }
      },

      /**
       * 上传雨量警戒值
       */
      setMobileRainWarn() {
        let warn = this.warnInput === '' ? 0 : parseFloat(this.warnInput);
        if(warn < 0){
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t("mobileCordonWarn")
          });
          this.warnInput = this.realWarnInput
        } else {
          let param = {rainWarn: warn};
          postClientInfo(this.credentialsId, param).then(response => {
            this.realWarnInput = this.realInput;
            this.$message({
              showClose: true,
              type: "info",
              message: this.$t("mobileCordonSuccess")
            });
          }).catch(error => {
            this.warnInput = this.realWarnInput;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t("mobileCordonError")
            });
            console.log("error",error)
          })
          this.mobileWarnDisplay();
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @media screen  and (max-width: 500px){
    .real-content {
      width: 90%;
      margin-left: 5%;
    }

    .realContent-minute1 {
      width: 100%;
      height: 20vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 3%;
      margin-top: 3%;

      .minute1-now {
        width: 49%;
        height: 20vw;
        //border: 1px outset #314963;
        //background-color: #314963;
        border: 1px outset rgba(49, 73, 99, 1);
        background-color: rgba(37, 70, 95, 0.5);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-family: SimSun;

        .minute1Now-name {
          width: 100%;
          height: 8vw;
          padding-top: 2vw;
          font-size: 5vw;
        }

        .minute1Now-value {
          width: 100%;
          height: 10vw;
          color: #83e2fd;
          font-size: 7vw;
        }
      }

      .minute1-one {
        width: 49%;
        height: 20vw;
        //border: 1px outset #314963;
        //background-color: #314963;
        border: 1px outset rgba(49, 73, 99, 1);
        background-color: rgba(37, 70, 95, 0.5);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-family: SimSun;

        .minute1One-name {
          width: 100%;
          height: 8vw;
          padding-top: 2vw;
          font-size: 5vw;
      }
      .minute1One-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }
    }
  }

  .realContent-minute2 {
    width: 100%;
    height: 20vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 3%;

    .minute2-five {
      width: 49%;
      height: 20vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .minute2Five-name {
        width: 100%;
        height: 8vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .minute2Five-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }
    }
    .minute2-ten {
      width: 49%;
      height: 20vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .minute2Ten-name {
        width: 100%;
        height: 8vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .minute2Ten-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }
    }
  }

  .realContent-hour {
    width: 100%;
    height: 20vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 3%;

    .hour-now {
      width: 49%;
      height: 20vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .hourNow-name {
        width: 100%;
        height: 8vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .hourNow-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }
    }

    .hour-last {
      width: 49%;
      height: 20vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .hourLast-name {
        width: 100%;
        height: 8vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .hourLast-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }
    }
  }

  .realContent-day {
    width: 100%;
    height: 20vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 3%;

    .day-now {
      width: 49%;
      height: 20vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .dayNow-name {
        width: 100%;
        height: 8vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .dayNow-value {
        width: 100%;
        height: 10vw;
        color: #83e2fd;
        font-size: 7vw;
      }

      .dayNow-value1 {
        width: 100%;
        height: 10vw;
        color: red;
        font-size: 7vw;
      }
    }
  }

  .realContent-input {
    width: 100%;
    height: 29vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 3%;

    .input-boundary {
      width: 49%;
      height: 29vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .inputBoundary-name {
        width: 100%;
        height: 9vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .inputBoundary-value {
        width: 100%;
        height: 10vw;
      }

      .inputBoundary-btn {
        width: 80%;
        height: 10vw;
        text-align:right;
        margin-left: 10%;
      }
    }

    .input-warn {
      width: 49%;
      height: 29vw;
      //border: 1px outset #314963;
      //background-color: #314963;
      border: 1px outset rgba(49, 73, 99, 1);
      background-color: rgba(37, 70, 95, 0.5);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-family: SimSun;

      .inputWarn-name {
        width: 100%;
        height: 9vw;
        padding-top: 2vw;
        font-size: 5vw;
      }

      .inputWarn-value {
        width: 100%;
        height: 10vw
      }

      .inputWarn-btn {
        width: 80%;
        height: 10vw;
        text-align: right;
        margin-left: 10%
      }
    }
  }
  .el-button {
    //background-color: #385D7A;
    border: 1px outset #385D7A;
    background-color: rgba(56, 93, 122, 0.5);
    width: 20vw;
    font-size: 5vw;
    line-height: 6vw;
    margin-left: 22%;
    color: #70eef4;
   }

   /deep/ .el-input__inner {
     height: 8vw;
     width: 80%;
     font-size: 5vw;
     border-radius: 20px;
     font-family: SimSun;
     /*border: none;*/
     //background-color: #314963;//rgba(49, 73, 99, 0.5) #314963 #3A83A8
     //border-color: #51BCDB;
     background-color: rgba(49, 73, 99, 0.1);
     border-color: rgba(91, 188, 219, 0.5);
     color: #ffffff;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileReal.vue